import {getUserInfo, login, logout} from '../service/user';

export const state = {
  page: 'home',
  dialog: {
    type: 1,
    title: '标题',
    data: {}
  },
  theme: localStorage.getItem('theme') || 2,
  user: {},
};

export const actions = {
  changeMainTheme({commit}, type) {
    localStorage.setItem('theme', type);
    commit('CHANGE_MAIN_THEME', type);
  },
  setDialogRef({commit}, el) {
  },

  async updateUserInfo({commit}) {
    const info = await getUserInfo();
    commit('SET_USER_INFO', info);
    return info;
  },

  getUserInfo({dispatch}) {
    if (state.user.uid) return state.user;
    return dispatch('updateUserInfo');
  },

  async login({commit}, info = {}) {
    const res = await login(info);
    if (res.result !== 'ok') return res;
    return res;
  },

  async logout({commit}) {

    const info = await logout();

    if (info.result !== 'ok') return;

    localStorage.removeItem('token');
    commit('CLEAR_USER_INFO');

    return true;
  }
};

export const mutations = {
  ['CHANGE_MAIN_THEME'](state, type) {
    state.theme = type;
  },
  ['SET_USER_INFO'](state, info) {
    state.user = info;
  },
  ['CLEAR_USER_INFO'](state) {
    state.user = {};
  },
};

export const getters = {
  theme: state => state.theme
};



// WEBPACK FOOTER //
// ./src/pages/store.js